<template>
  <div class="grid-galeria">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'grid-galeria'
}
</script>

<style scoped lang="scss">
.grid-galeria {
  display: grid;
  grid-gap: $gap;
  grid-template-columns: repeat(1, 1fr);

  @media (min-width: map-get($media-queries-since, "md")) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (min-width: map-get($media-queries-since, "lg")) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (min-width: map-get($media-queries-since, "xl")) {
    grid-template-columns: repeat(3, 1fr);
  }
}
</style>
